export default class PanelStickyHeaderView extends Backbone.View
  events:
    "click .js-touch-nav" : "onHamburgerClick"
    "click .js-toggle-collapsible.fixed-sticky-header" : "preventToggle"

  initialize: (options) ->
    super(options)

    @touchDevice = contently.ui.touch_device
    @stickyMap = []
    @pageHeight = $("#page-container").outerHeight(true)

    @resetHeader()

    $(window).resize (e) =>
      _.throttle(@decideWhatToSticky(e), 100)

    $(document).scroll (e) =>
      _.throttle(@decideWhatToSticky(e), 100)

  resetHeader: ->
    # variables that need to update on external calls
    @$mainHeaderWrapper = $(".panel-header-wrapper")
    @$mainHeader = @$mainHeaderWrapper.find(".header-wrapper")

    @mainHeaderOffsetTop = @$mainHeaderWrapper.offset().top
    @mainHeaderSlimTop = $(".panel-wrapper").offset().top - 50

    # we use a clone because sometimes we have to
    # recalculate the height but the original could be
    # in its slim state, therefore not accurate
    # ex: if a user resizes the window both ways
    #     we cannot use a stored height as it changed
    @$hiddenHeaderClone = @$mainHeader.clone()
    @$hiddenHeaderClone.addClass("clone")

    $(document).scroll()

  slidePanelChange: (timeout=350) ->
    return if @touchDevice

    # slides the nav off screen until the panel slide (300ms)
    # finishes animating, then recalculate the width
    # and slide the nav back on screen. no drama jump.
    currentStickyBar = $(".fixed-sticky-header")
    return unless currentStickyBar.length == 1

    currentStickyBar.css("top", "-100px")
    setTimeout (=>
      $(document).scroll()
      currentStickyBar.css("top", "0")
    ), timeout

  onHamburgerClick: (timeout=400) ->
    return if @touchDevice

    # default slidedown of nav is 400ms
    setTimeout (=>
      $(document).scroll()
    ), timeout

  decideWhatToSticky: (e) ->
    return if @touchDevice
    currentPosition = $(e.target).scrollTop()

    @generateStickyMap() # only on certain conditions

    if currentPosition < @mainHeaderOffsetTop
      # at top of the page, everything should be normal
      return @resetAllHeaders()

    if @mainHeaderOffsetTop < currentPosition < @mainHeaderSlimTop
      # use a sticky normal main header if we're not quite
      # at the checkpoint to slim the main header
      return @useNormalMainHeader(currentPosition)

    if currentPosition > @mainHeaderSlimTop
      # always use a sticky slim main header past this point
      # regardless if we find any other stickies
      @useSlimMainHeader()

      unless @stickyMap.length == 0
        @decideStickySection(currentPosition)

  decideStickySection: (currentPosition) ->
    mainHeaderHeight = @$mainHeader.outerHeight(true)

    # before first push off header, use main then exit
    firstStickyTop = @stickyMap[0].sectionTop - mainHeaderHeight
    if firstStickyTop > currentPosition
      return @returnToMainHeader()

    # after the last sticky, use main then exit
    lastStickyBottom = @stickyMap[@stickyMap.length-1].sectionBottom
    if currentPosition > lastStickyBottom
      return @returnToMainHeader()

    # if not at the beginning or end of page
    # then find out where we are
    for sticky, index in @stickyMap
      sectionStart = sticky.sectionTop
      sectionBottom = sticky.sectionBottom
      pushMainHeader = sectionStart - mainHeaderHeight

      # only calculate if its the current section
      # exits loop completely when any statement returns true
      if pushMainHeader < currentPosition < sectionBottom
        return if sticky.skip is true

        if currentPosition < sectionStart
          return @pushMainHeaderOff(sticky, currentPosition)

        if sectionStart <= currentPosition < sectionBottom
          return @stickySectionHeader(sticky, currentPosition)

      else
        continue unless index == @stickyMap.length-1

        # if we're in between the next section
        # we should use the main header if early exits
        @returnToMainHeader()

  preventToggle: (e) ->
    # prevent the toggle collapse on current stuck bar
    unless $(e.target).is(".actions *")
      e.stopPropagation()

  generateStickyMap: ->
    # .js-sticky-section = container that has a sticky bar
    # .js-sticky-bar = bar in section to be stuck

    currentSections = $(".js-sticky-section")
    currentPageHeight = $("#page-container").outerHeight(true)
    pageHeightChanged = (@pageHeight != currentPageHeight)
    sectionCountChanged = (currentSections.length != @stickyMap.length)

    # rehash if either page height or map length changes
    if pageHeightChanged || sectionCountChanged
      @pageHeight = currentPageHeight

      # rebuild hash
      for section, index in currentSections
        $bar = $(section).find(".js-sticky-bar")
        barHeight = $bar.outerHeight(true)
        minSectionHeight = barHeight*4
        sectionHeight = $(section).outerHeight(true)
        sectionTop = $(section).offset().top
        sectionBottom = sectionTop + sectionHeight - minSectionHeight

        noStickyBar = false
        if sectionHeight == barHeight
          noStickyBar = true # skip if collapsed
        if sectionHeight < minSectionHeight
          noStickyBar = true # skip if not enough height

        @stickyMap[index] =
          bar: $bar
          barHeight: barHeight
          section: $(section)
          sectionTop: sectionTop
          sectionBottom: sectionBottom
          skip: noStickyBar

  resetAllHeaders: ->
    @$mainHeader
      .removeClass("fixed-main-header fixed-main-slim")
      .removeAttr("style")
    @$hiddenHeaderClone.remove()
    @resetStickySections()

  stickyMainHeader: ->
    return if @$mainHeader.hasClass("fixed-main-header")
    @$mainHeader.addClass("fixed-main-header")
    @$mainHeaderWrapper.append(@$hiddenHeaderClone)

  useNormalMainHeader: (currentPosition) ->
    @stickyMainHeader()
    @$mainHeader.removeClass("fixed-main-slim")

    headerHeight = @$hiddenHeaderClone.outerHeight(true)
    panelTop = $(".panel-wrapper").offset().top

    # smooth slimming of normal main header to avoid drama jump
    pushHeader = headerHeight - (panelTop - currentPosition)
    if 0 < pushHeader <= 30
      @$mainHeader.css
        "padding-top": "#{25-Math.floor(pushHeader/2)}px"
        "padding-bottom": "#{25-Math.ceil(pushHeader/2)}px"
    else if pushHeader > 30
      @$mainHeader.css
        padding: "10px 0"
        top: 0

  useSlimMainHeader: ->
    @stickyMainHeader()
    return if @$mainHeader.hasClass("fixed-main-slim")
    @$mainHeader
      .addClass("fixed-main-slim")
      .css("padding", "10px 0")

  returnToMainHeader: ->
    @resetPushedMainHeader()
    @resetStickySections()

  resetPushedMainHeader: ->
    # resets main header to top
    @$mainHeader
      .removeClass("no-bounce-push-up")
      .css("top", "0")

  resetStickySections: ->
    # reset sticky section styles
    $(".js-sticky-section").removeAttr("style")
    $(".js-sticky-bar")
      .removeClass("fixed-sticky-header")
      .removeAttr("style")

  pushMainHeaderOff: (sticky, currentPosition) ->
    headerHeight = @$mainHeader.outerHeight(true)
    pushHeader = headerHeight - (sticky.sectionTop - currentPosition)

    if 0 < pushHeader <= headerHeight
      @$mainHeader
        .addClass("no-bounce-push-up")
        .css("top", "-#{pushHeader}px")

    @resetStickySections()

  stickySectionHeader: (sticky, currentPosition) ->
    # main bar should be hidden
    @$mainHeader
      .removeClass("no-bounce-push-up")
      .css("top", "-100px")

    sticky.section.css
      'padding-top': sticky.barHeight

    zenMode = $("#page-container").hasClass("zen-mode")
    sectionWidth = sticky.section.outerWidth(true)
    sectionLeft = sticky.section.offset().left
    paddingRight = $(".panel.meta").offset().left - sectionWidth - sectionLeft
    contentLeft = $(".panel-content-wrapper").offset().left

    if !zenMode and $(".panel-wrapper").hasClass("hide-meta")
      # if meta panel is collapsed, adjust for panel nav
      paddingRight -= 4

    # account for really big screens and borders
    if contentLeft >= 1
      paddingRight -= 1
      contentLeft += 1

    # account for responsive panel nav
    if $(".nav-meta.mobile").is(":visible")
      paddingRight = $("#page-container").outerWidth() - sectionWidth - sectionLeft

    sticky.bar
      .addClass("fixed-sticky-header")
      .css
        position: "fixed"
        width: sectionWidth
        "padding-left": sectionLeft - contentLeft
        "padding-right": paddingRight
        left: contentLeft



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/panel_sticky_header_view.js.coffee